import React from 'react';
import './KSSelector.scss';
import classNames from 'classnames';

export type KSSelectorOption = {
  value: string;
  label: string;
};

export type KSSelectorProps = {
  /** Array of options to display */
  options: KSSelectorOption[];
  /** Currently selected value */
  value: string;
  /** Callback when selection changes */
  onChange: (value: string) => void;
  /** Custom class name */
  className?: string;
  /** Disabled state */
  disabled?: boolean;
};

const KSSelector: React.FC<KSSelectorProps> = ({ options, value, onChange, className = '', disabled = false }) => {
  const handleClick = (optionValue: string) => {
    if (!disabled && optionValue !== value) {
      onChange(optionValue);
    }
  };

  return (
    <div
      className={classNames('ks-selector', {
        [className]: className,
        disabled: disabled,
      })}
    >
      {options.map(option => (
        <button
          key={option.value}
          className={classNames('ks-selector__option', {
            'ks-selector__option--active': option.value === value,
          })}
          onClick={() => handleClick(option.value)}
          disabled={disabled}
          type="button"
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default KSSelector;
